import { z } from "zod";

export const selectedTimeScheme = z.object({
  time: z.string().min(1),
});

export type SelectedTimeFormScheme = z.infer<typeof selectedTimeScheme>;
